import React from "react";
import "./index.scss";

export default function Button({
  text,
  type = "primary",
  disabled = false,
  topPadding = 0,
  bottomPadding = 0,
  onClick,
  style,
}) {
  const className = `btn ${type}`;

  return (
    <button
      className={className}
      style={{ ...style, paddingTop: topPadding, paddingBottom: bottomPadding }}
      disabled={disabled}
      onClick={onClick}
    >
      {text}
    </button>
  );
}
